<template>
  <div id="tab1">
    <h1>Tab 1</h1>
    <p>Example tab menu 1 case is default.</p>
  </div>
</template>

<script>
export default {
  name: 'Tab1'
}
</script>